export enum EntityType {
  Availability = 'availability',
  Property = 'property',
  LeaseComp = 'lease',
  SaleComp = 'sale',
  PortfolioSale = 'portfoliosale',
  Company = 'company',
  Contact = 'contact',
  Tim = 'tim',
  Tenancy = 'tenancy',
  Brand = 'brand',
  Complex = 'complex',
  Tenants = 'tenants',
}

export const entitiesWithConfidentiality = {
  [EntityType.LeaseComp]: true,
  [EntityType.SaleComp]: true,
  [EntityType.Tim]: true,
  [EntityType.Availability]: true,
};
